
<!-- <div class="page-wrapper"  [ngClass]="{'toggled' : getSideBarState()}">
  <app-header-main></app-header-main>
  <app-sidebar></app-sidebar>
 
  <main class="page-content" >
   
      <div class="container-fluid"  >
       
     
            <router-outlet></router-outlet>
         
   </div>
  </main>

</div> -->
<!-- <mat-toolbar class="mat-elevation-z6" color="primary">
  <app-header-main></app-header-main>
</mat-toolbar>
<mat-sidenav-container>
<mat-sidenav  mode="side"
            opened="true"
            [fixedInViewport]="true"
            [fixedTopGap]="64">
            <app-sidebar></app-sidebar>
  </mat-sidenav>
  <div> 
    <main class="page-content" >
          <router-outlet></router-outlet>
</main>
</div>
</mat-sidenav-container> -->

<mat-toolbar class="example-toolbar">
	<button mat-icon-button (click)="isExpanded = !isExpanded"><mat-icon>menu</mat-icon></button>
	<app-header-main></app-header-main>
</mat-toolbar>
<mat-sidenav-container class="example-container" autosize>
	<mat-sidenav #sidenav class="example-sidenav" mode="side" opened="true" (mouseenter)="mouseenter()" (mouseleave)="mouseleave()">
		<mat-nav-list>
			<!-- <mat-list-item (click)="showSubmenu = !showSubmenu" class="parent">
				<span class="full-width" *ngIf="isExpanded || isShowing">Parent Menu</span>
				<mat-icon mat-list-icon>home</mat-icon>
				<mat-icon class="menu-button" [ngClass]="{'rotated' : showSubmenu}" *ngIf="isExpanded || isShowing">expand_more</mat-icon>
			</mat-list-item> -->
			<div class="submenu" [ngClass]="{'expanded' : showSubSubMenu}" *ngIf="isShowing || isExpanded" style="min-height: 700px;min-width: 310px;margin-top: -10px;overflow: hidden !important;">
				<!-- <a mat-list-item href="...">Submenu Item 1</a>
				<a mat-list-item href="...">Submenu Item 2</a> -->
				
				<!-- <div class="submenu" [ngClass]="{'expanded' : showSubSubMenu}" *ngIf="isShowing || isExpanded">
					<mat-list-item>SubSubmenu Item 1</mat-list-item>
					<mat-list-item>SubSubmenu Item 2</mat-list-item>
				</div> -->
        <app-sidebar></app-sidebar>
			</div>
		</mat-nav-list>
  
	</mat-sidenav>
	
    <!-- <ng4-loading-spinner [loadingText]="'Please wait...'" ></ng4-loading-spinner> -->
   
	<div class="example-sidenav-content">
		
        <div id="overlay" *ngIf="iSLoading" >
			<div id="loading-center">
				<div id="loading-center-absolute">
					<div class="object" id="object_four"></div>
					<div class="object" id="object_three"></div>
					<div class="object" id="object_two"></div>
					<div class="object" id="object_one"></div>
				</div>
			</div>
		</div>
		<!-- <app-dashboard></app-dashboard> -->
    <router-outlet></router-outlet>
	</div>
	

</mat-sidenav-container>
